import { render, staticRenderFns } from "./BiographyMainCard.vue?vue&type=template&id=97976076&"
import script from "./BiographyMainCard.vue?vue&type=script&lang=js&"
export * from "./BiographyMainCard.vue?vue&type=script&lang=js&"
import style0 from "./BiographyMainCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BiographyMainCard.vue"
export default component.exports